import { FC } from 'react';

import { AnalyticsSection } from '@/shared/api/transcriptor/transcriptorApi';

import styles from '../AnalyticsView.module.scss';

type AnalyticsSectionBlockProps = {
  section: AnalyticsSection;
};

export const AnalyticsSectionBlock: FC<AnalyticsSectionBlockProps> = (
  props,
) => {
  const { section } = props;
  const { content } = section;
  const text = content.text?.trim();

  return (
    <section
      className={styles.sectionsBlock}
      data-component="analytics-section-block"
    >
      <h3 className={styles.sectionHeading}>{section.name}</h3>
      {content.kind === 'list' && content.items && content.items.length > 0 && (
        <ul className={styles.list}>
          {content.items.map((item, index) => (
            <li key={`${section.code}-item-${index}`}>{item}</li>
          ))}
        </ul>
      )}
      {content.kind !== 'list' && text && (
        <p className={styles.paragraph}>{text}</p>
      )}
    </section>
  );
};
